import React, { Component } from 'react';

import { TopicVo } from '../classes/dataObjects/TopicVo';
import { MainStorage } from '../classes/MainStorage';
interface MyProps { topicVo: TopicVo, callback: Function,useGray:boolean }
interface MyState { topicVo: TopicVo,useGray:boolean }
class TreeImage extends Component<MyProps, MyState> {
    private ms:MainStorage=MainStorage.getInstance();
    constructor(props: MyProps) {
        super(props);
        this.state = { topicVo: this.props.topicVo,useGray:this.props.useGray };
    }
    componentDidUpdate(prevProps: Readonly<MyProps>, prevState: Readonly<MyState>, snapshot?: any): void {
        if (prevProps.topicVo !== this.props.topicVo) {
            this.setState({ topicVo: this.props.topicVo });
        }
        if (prevProps.useGray !== this.props.useGray) {
            this.setState({ useGray: this.props.useGray });
        }
    }
    onImageLoaded() {
        this.setState({});
    }
    onClicked() {
        this.props.callback(this.state.topicVo);
    }
    render() {
        let imageClass: string = 'topicImage';
        if (this.state.useGray) imageClass += ' greyscale';
        let image: string = "https://memorywizards.com/api/direct/getTopicImage.php?subjectID=" + this.state.topicVo.subjectID + "&topicID=" + this.state.topicVo.id + "&size=3"
        
        if (this.ms.subjectID === 1) {
            console.log("icon:"+this.state.topicVo.icon);
            image ="https://memorywizards.com/api/direct/getLangImage.php?diff="+this.state.topicVo.difficulty+"&icon="+this.state.topicVo.icon+"&size=3";
        }
        let topicName: string = this.state.topicVo.topicName;
        //replace dashes and underscores with spaces
        topicName = topicName.replace(/-/g, ' ');
        topicName = topicName.replace(/_/g, ' ');
        //capitalize first letter of each word
        topicName = topicName.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
        return (
            <div className='treeImage'><div className={imageClass} style={{ backgroundImage: `url(${image})` }} onClick={this.onClicked.bind(this)}></div>
            <div className='topicName'>{topicName}</div>
            </div>
        )
    }
}
export default TreeImage;